import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Layout } from '@/components/layout/Layout';
import { TemplateGallery } from '@/components/templates/TemplateGallery';
import { QRTemplate, UserTemplate } from '@/hooks/useTemplates';
import { useQRStore, QRDesignSettings, DotsType, CornersSquareType, CornersDotType } from '@/stores/qrStore';
import { toast } from 'sonner';

export default function Templates() {
  const navigate = useNavigate();
  const { setCurrentQR, setDesignSettings } = useQRStore();

  const handleSelectTemplate = (template: QRTemplate | UserTemplate) => {
    const settings = template.design_settings;
    
    // Build full design settings with defaults
    const fullDesignSettings: Partial<QRDesignSettings> = {
      dotsColor: settings.dotsColor || '#1a1a2e',
      backgroundColor: settings.backgroundColor || '#ffffff',
      dotsType: (settings.dotsType || 'rounded') as DotsType,
      cornersSquareType: (settings.cornersSquareType || 'extra-rounded') as CornersSquareType,
      cornersDotType: (settings.cornersDotType || 'dot') as CornersDotType,
      cornersSquareColor: settings.cornersSquareColor || settings.dotsColor || '#1a1a2e',
      cornersDotColor: settings.cornersDotColor || settings.dotsColor || '#1a1a2e',
    };

    // Apply frame settings if available
    if (settings.frame) {
      fullDesignSettings.frame = settings.frame as QRDesignSettings['frame'];
    }

    // Apply gradient if available
    if (settings.gradient) {
      fullDesignSettings.gradient = settings.gradient as QRDesignSettings['gradient'];
    }

    // Set QR type and design
    setCurrentQR({
      type: template.qr_type,
      contentData: {},
    });
    setDesignSettings(fullDesignSettings);

    toast.success(`Template "${template.name}" applied!`);
    navigate('/create');
  };

  return (
    <Layout>
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6 md:py-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <h1 className="text-2xl md:text-3xl font-black tracking-tight mb-1">Template Gallery</h1>
          <p className="text-muted-foreground">
            Choose from 35+ professionally designed QR code templates
          </p>
        </motion.div>

        <TemplateGallery onSelectTemplate={handleSelectTemplate} />
      </div>
    </Layout>
  );
}
